import React from '/web_modules/react.js';
export const delay = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
export const randomDelayPromise = promise => {
  const d = Math.random() * 300;
  return delay(d).then(() => promise);
};
export function shuffleArray(array) {
  const copy = [...array];

  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }

  return copy;
}
export const toTuple = a => b => [a, b];
export const lazyWithPreload = factory => {
  const promise = factory();
  const Component = /*#__PURE__*/React.lazy(() => promise);
  return Component;
};